import Fetching from "@/components/Fetching/Fetching";
import { CheckCircle2, CircleX } from "lucide-react";

import classes from "./integration.module.scss";
import IntegrationSyncMessage from "./IntegrationSyncMessage";

const IntegrationSale = ({ completeOrder, completeOrderSale, completeOrderDelivery, hasError = false, messageLines = [], messageOrderSale = "" }) => {
	const lines = messageLines.length > 0 ? messageLines : messageOrderSale ? [messageOrderSale] : [];

	return (
		<div
			className={`${classes.content} ${completeOrder && completeOrderDelivery && !completeOrderSale && classes.inProcess} ${
				completeOrderSale && classes.complete
			}`}
		>
			<div>
				Obteniendo Facturas
				<IntegrationSyncMessage messageLines={lines} />
			</div>
			<div>
				{completeOrder && completeOrderDelivery && !completeOrderSale && <Fetching topMargin={"0px"} />}{" "}
				{completeOrderSale && !hasError && <CheckCircle2 className={`${classes.checkIcon} ${classes.successIcon}`} />}
				{completeOrderSale && hasError && <CircleX className={`${classes.checkIcon} ${classes.errorIcon}`} />}
			</div>
		</div>
	);
};

export default IntegrationSale;
